export default __webpack_public_path__ + "static/media/tabletMode.94457274.svg";